import { defineField } from 'sanity';

export const CurrentBenefitSectionSchema = defineField({
	name:   'currentBenefitSection',
	title:  'Current Benefit Section',
	type:   'object',
	fields: [
		defineField({
			name:       'title',
			title:      'Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:  'description',
			title: 'Description',
			type:  'localizedText',
		}),
		defineField({
			name:   'egg',
			title:  'Egg',
			type:   'object',
			fields: [
				defineField({
					name:  'benefits',
					title: 'Benefits',
					type:  'array',
					of:    [
						{
							type:   'object',
							fields: [
								defineField({
									name:       'title',
									title:      'Title',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
								defineField({
									name:       'description',
									title:      'Description',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
							],
						},
					],
				}),
			],
		}),
		defineField({
			name:   'babyTurtle',
			title:  'Baby Turtle',
			type:   'object',
			fields: [
				defineField({
					name:  'benefits',
					title: 'Benefits',
					type:  'array',
					of:    [
						{
							type:   'object',
							fields: [
								defineField({
									name:       'title',
									title:      'Title',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
								defineField({
									name:       'description',
									title:      'Description',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
							],
						},
					],
				}),
			],
		}),
		defineField({
			name:   'seaTurtle',
			title:  'Sea Turtle',
			type:   'object',
			fields: [
				defineField({
					name:  'benefits',
					title: 'Benefits',
					type:  'array',
					of:    [
						{
							type:   'object',
							fields: [
								defineField({
									name:       'title',
									title:      'Title',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
								defineField({
									name:       'description',
									title:      'Description',
									type:       'localizedText',
									validation: Rule => Rule.required(),
								}),
							],
						},
					],
				}),
			],
		}),
	],
});